import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import { Button, Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close"
import { useState, useEffect } from "react";
import axios from 'axios';
import WellNumber from '../Reusable/WellNumber';


const columns2 = [
    {field: 'well', headerName: 'Well', width: 50, editable: false, sortable: false, filterable: false, hideable: false,
    valueGetter: (params) => {
      return WellNumber(params.row.well);
    }},
    {field: 'name', headerName: 'Sample', width: 100, editable: false, sortable: false, filterable: false, hideable: false,},
    {field: 'targetConcentration', headerName: 'Target Conc (ng)', width: 150, editable: true, sortable: false, filterable: false, hideable: false,},
    {field: 'concentration', headerName: 'Conc (ng/uL)', width: 100, editable: false, sortable: false, filterable: false, hideable: false,},
    {field: 'volume', headerName: 'Volume (uL)', width: 100, editable: false, sortable: false, filterable: false, hideable: false,
    valueGetter: (params) => {
      return targetVol(params.row.targetConcentration, params.row.concentration);
    }},
    {field: 'add', headerName: 'H2O Add', width: 100, editable: false, sortable: false, filterable: false, hideable: false,
    valueGetter: (params) => {
        return h2oAdd(targetVol(params.row.targetConcentration, params.row.concentration));
    }},
    {field:'template', headerName: 'Desired Template', width: 200, editable: false, sortable: false, filterable: false, hideable: false,
    valueGetter: (params) => {
      return params.row.sangerTemplate;
    }}
];

const columnsT = [
  { field: 'reagent', headerName: '', width: 200, editable: false, sortable: false, filterable: false, hideable: false, },
  {
    field: 'reaction',
    headerName: '# of Reactions',
    width: 150,
    editable: true, sortable: false, filterable: false, hideable: false,
  },
  {
    field: 'volume',
    headerName: 'Volume (µL)',
    width: 150,
    editable: false, sortable: false, filterable: false, hideable: false,
    valueGetter: (params) => {
      return BidDyeTerminatorVol(params.row.reaction);
    }
  },
];

const colSeqStudio = [
  {field: 'name', headerName: 'Sample', width: 100, editable: false, sortable: false, filterable: false, hideable: false,}
];

//Functions
function BidDyeTerminatorVol(reactions) {
    const volume = (reactions / 4) * 2.25;
    return volume.toFixed(2);
}
function BigDyeTerminatorVolBuffer(reactions) {
    const volume = (reactions / 4) * 7;
    return volume.toFixed(2);
}
function NucleaseFreeH20Vol(reactions) {
    const volume = (reactions / 4) * 26.75;
    return volume.toFixed(2);
}
function targetVol(target, conc) {
    const vol = (target / conc).toFixed(2);
    return vol;
}
function h2oAdd(volume) {
    var add = 0;
    if (volume < 1) {
        add = 1 - volume;
    }
    return add.toFixed(2);
}

const API_ENDPOINT =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_API_ENDPOINT_PROD
    : process.env.REACT_APP_API_ENDPOINT_DEV


const Reagent = (props) => {
  const sampleMapId = props.sampleMapId;
  console.log(sampleMapId);
  console.log('sample map id here')
  const [open, openchange]=useState(false);
  const [noOfReactions, setNoOfReactions] = useState(0);
  const [samples, setSamples] = useState([]);
  const [machineSampleNames, setmachineSampleNames] = useState([])

  const rowsT = [
    { id: '1', reagent: 'Big Dye Terminator', reaction: noOfReactions, volume: BidDyeTerminatorVol(noOfReactions)},
    { id: '2', reagent: 'Big Dye Terminator Buffer', reaction: noOfReactions, volume: BigDyeTerminatorVolBuffer(noOfReactions)},
    { id: '3', reagent: 'Nuclease-free H2O', reaction: noOfReactions, volume: NucleaseFreeH20Vol(noOfReactions)},
  ];

    const functionopenpopup=()=>{
        openchange(true);
    }
    const closepopup=()=>{
        openchange(false);
  }


  async function getSampleData() {
    const res = await axios({
      method: 'GET',
      url: `${API_ENDPOINT}/samplemaps/${sampleMapId}`
    });
    if (res.status == 200) {
      const data = res.data;
      var sampleData = res.data.samples;
      setNoOfReactions(sampleData.length);
      let machineSamples = [];
      for (let i = 0; i < sampleData.length; i = i + 1) {
        sampleData[i] = {...sampleData[i], id: (i + 1)}
        machineSamples.push({...sampleData[i], id: (i + 1)})
      }
      machineSamples.sort(function(a, b){return a.well - b.well});
      let lastIdVal = machineSamples.length + 1;
      for (let i = 0; i < machineSamples.length; i = i + 1) {
        if (i % 8 == 0 && i != 0) {
          machineSamples.splice(i, 0, ({id: i + lastIdVal, well: '', name: '', targetConcentration: 0, concentration: 0, volume: 0, add: 0, template: ''}));
        }
      }
      setmachineSampleNames(machineSamples)

      // sampleData.push({id: sampleData.length + 1, well: 0, name: '', targetConcentration: 0, concentration: 0, volume: 0, add: 0, template: ''});
      sampleData.sort(function(a, b){return a.well - b.well});
      console.log(sampleData);
      setSamples(sampleData);
    }
  }

  async function changeTargetConcentration(sample_Id, newTargetConC) {
    const res = await axios({
      method: 'PATCH',
      url: `${API_ENDPOINT}/samples/${sample_Id}`,
      data: {
        targetConcentration: newTargetConC
      }
    });
    console.log(res.data);
  }


  useEffect(() => {
    getSampleData();
  }, [open])

  return (
      <div>
      <Button onClick={functionopenpopup} color="primary" variant="contained">Reagent Tables</Button>
      <Dialog open={open} onClose={closepopup} fullWidth maxWidth="100">
          <DialogTitle>Reagent Table<IconButton onClick={closepopup} style={{float:'right'}}><CloseIcon color="primary"></CloseIcon></IconButton>  </DialogTitle>
          <DialogContent>
              <Box sx={{ height: 300, width: '60%'}}>
                <DataGrid rows={rowsT} columns={columnsT} 
                isCellEditable={(params) => params.row.id == 1} 
                onCellEditStop={(params, event) => {
                  if (params.row.id == 1) {
                    setNoOfReactions(event.target.value)
                  }
                }}/>
              </Box>
              <Box sx={{ height: 400, width: '70%'}}>
                <DataGrid rows={samples} columns={columns2} 
                onCellEditStop={(params, event) => {
                changeTargetConcentration(params.row._id, event.target.value)
              }}/>
              </Box>
              <Box sx={{ height: 800, width: '20%'}}>
                <DataGrid rows={machineSampleNames} columns={colSeqStudio}  />
              </Box>
          </DialogContent>
      </Dialog>
      </div>
  );
}

export default Reagent;
